<form
    [formGroup]="searchForm"
    (ngSubmit)="onSubmitOffice()"
>
    <input
        class="search-input office-search"
        formControlName="searchInput"
        placeholder="{{consts.PLACEHOLDER_SEARCH_BOX}}"
        [matAutocomplete]="auto"
        #clearInputField
        [appClearInput]="clearInputField.value"
    >
    <mat-icon
        class="search-icon"
        (click)="onSubmitOffice()"
        svgIcon="hub_search"
    >
    </mat-icon>
    <mat-autocomplete #auto="matAutocomplete">
        <div *ngIf="recents$ | async as recentSearchTerms">
            <ng-container *ngIf="recentSearchTerms.length > 0">
                <div class="search-header">Recent Searches</div>
                <mat-option
                    class="search-terms"
                    *ngFor="let item of recentSearchTerms"
                    [value]="item"
                >
                    <mat-icon
                        class="recent-search-icon"
                        svgIcon="hub_search"
                    >
                    </mat-icon>
                    {{item}}
                </mat-option>
            </ng-container>
        </div>
    </mat-autocomplete>
    <a
        class="es-tooltip"
        href="{{consts.ENTERPRISE_SEARCH_LINK}}"
        target="_blank"
        appTooltip="{{consts.ENTERPRISE_SEARCH_TOOLTIP_MESSAGE}}"
        tooltipPosition="right"
        tooltipCustomClass="es-link-tooltip"
    >
        <mat-icon svgIcon="hub_info"></mat-icon>
    </a>
</form>
